import { render, staticRenderFns } from "./Detailpm.vue?vue&type=template&id=b425328c&scoped=true"
import script from "./Detailpm.vue?vue&type=script&lang=js"
export * from "./Detailpm.vue?vue&type=script&lang=js"
import style0 from "./Detailpm.vue?vue&type=style&index=0&id=b425328c&prod&lang=scss"
import style1 from "./Detailpm.vue?vue&type=style&index=1&id=b425328c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b425328c",
  null
  
)

export default component.exports